const langMap = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  it: 'it',
  es: 'es',
};

export const getLanguage = (): string | undefined => {
  const lang = location.pathname.replace(/^\/+/g, '').split('/')[0];

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return langMap[lang as keyof typeof langMap] || langMap.en;
};
